module.exports = __webpack_public_path__ + "media/newstyle/images/record_voice_over-eb49cc358363bfedce205c312c432344.svg";